import * as layout from '../../../components/markLayout.module.css';
import React from 'react';
import P from '@hero/ui-kit/typography/P';
const DemoModeBanner: React.FC = () => (
    <div
        role="status"
        style={{
            backgroundColor: 'var(--mark-warning-surface)',
            marginBottom: '1.2rem',
            color: 'var(--mark-warning)'
        }}
        className={layout.panel}
    >
        <P noDefaultMargin size="small">
            <strong>Demo mode.</strong> Only profiles with <code>is_demo = true</code> can be
            enrolled here.
        </P>
        <P
            noDefaultMargin
            size="small"
            styles={{
                marginTop: '0.4rem'
            }}
        >
            This instance list is kept only while this page is open — refreshing loses it.
            Fast-forward only makes the SendJob due; the backend cron performs progression.
        </P>
        <P
            noDefaultMargin
            size="small"
            strong
            styles={{
                marginTop: '0.4rem'
            }}
        >
            No email/SMS mock is confirmed on this backend yet. Enroll creates a SendJob that is
            already due, so the next cron tick can send a real message via the live provider to
            whatever address/phone is on the demo profile — Fast-forward does the same for later
            steps. Only use Enroll or Fast-forward once that mock gate is in place.
        </P>
    </div>
);
export default DemoModeBanner;
